import controller from './checkbox-group.controller'
import template from './checkbox-group.html'

const CheckboxGroupComponent = {
	bindings: {
		checkItems: '<',
		class: '<',
		onChange: '&'
	},
	controller,
	template,
};

export default CheckboxGroupComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/checkbox-group/checkbox-group.component.js